<ng-template [ngIf]="isClient" [ngIfElse]="notClient">
    <div class="mh-0 h-100 d-flex flex-column">
        <app-client-header class="sticky-top"></app-client-header>
        <div class="d-flex h-100 mh-0">
            <div class="content">
                <router-outlet></router-outlet>
                <app-stack-panel-host></app-stack-panel-host>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #notClient>
    <div class="mh-0 h-100 d-flex flex-column">
        <app-header-component class="sticky-top" (onChangedSidebar)="onChangedSidebar()"></app-header-component>
        <div class="d-flex h-100 mh-0">
            <app-sidebar-component></app-sidebar-component>
            <div class="content">
                <router-outlet></router-outlet>
                <app-stack-panel-host></app-stack-panel-host>
            </div>
        </div>
    </div>
    <app-user-guide></app-user-guide>
    <app-pdf-converter-monitor></app-pdf-converter-monitor>
</ng-template>

<app-toast></app-toast>
<app-fde-long-polling></app-fde-long-polling>
<app-mfa></app-mfa>
